import { Icon } from 'components/ui/Icon'
import { memo, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { sendMessageFeedback } from 'api/feedback'
import { ChatMessage, FeedbackEnum } from 'types/chat-message'
import { ChatRoleEnum } from 'types/chat'
import { ChatBubble } from 'components/messages/ChatBubble'
import { ChatBotAvatar } from 'components/chats/ChatBotAvatar'
import { MessageContent } from 'components/messages/MessageContent'

type TextMessageProps = {
  messageItem: ChatMessage
  text: string
  startsSequence?: boolean
  endsSequence?: boolean
  showBotAvatar?: boolean
  isOperator?: boolean
  img?: JSX.Element
  isFirstMessage?: boolean
}

const TextMessageComponent = ({ text, showBotAvatar, messageItem, img, isFirstMessage }: TextMessageProps) => {
  const { t } = useTranslation()
  const [feedback, setFeedback] = useState<FeedbackEnum | undefined>(messageItem.feedback)

  const onPressDisLike = useCallback(async () => {
    setFeedback(FeedbackEnum.BAD)
    await sendMessageFeedback({
      messageId: messageItem._id,
      feedback: FeedbackEnum.BAD,
    })
  }, [])

  const showFeedback = useMemo(() => {
    return messageItem.chatSenderRole === ChatRoleEnum.BOT && !isFirstMessage
  }, [messageItem, isFirstMessage])

  return (
    <div className="tw-flex tw-flex-row tw-items-end tw-space-x-1">
      <div className={`tw-flex tw-w-10 tw-items-end tw-shrink-0`}>
        {img && <div className={'tw-h-10 tw-w-10'}>{img}</div>}
        <ChatBotAvatar visible={showBotAvatar} />
      </div>
      <div className="tw-flex tw-min-w-[10%] tw-max-w-[80%] tw-flex-col tw-space-x-2">
        <ChatBubble variant="bot" timestamp={messageItem.createdAt}>
          <MessageContent text={text} />
        </ChatBubble>
      </div>
      {showBotAvatar && (
        <div className={'tw-row-auto justify-between'}>
          {showFeedback && (
            <>
              <button
                type="button"
                aria-label={t('badResponse')}
                aria-pressed={feedback === FeedbackEnum.BAD}
                onClick={onPressDisLike}
                className={'tw-mr-2 tw-ml-2'}
              >
                <Icon
                  aria-hidden
                  icon={['far', 'thumbs-down']}
                  style={{ color: feedback === 'bad' ? '#ef4444' : 'var(--text-tertiary)' }}
                />
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export const TextMessage = memo(TextMessageComponent)
